import { isDefined } from "@clipboard-health/util-ts";
import { useTheme } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { BaseChartingCard } from "@src/appV2/redesign/Charting/Cards/BaseChartingCard";
import { ChartingCardWrapper } from "@src/appV2/redesign/Charting/Cards/ChartingCardWrapper";
import { Button } from "@src/appV2/redesign/components/Button";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";
// eslint-disable-next-line no-restricted-imports
import UnfinishedTask from "@src/assets/images/unfinishedTask.png";
import { differenceInMinutes } from "date-fns";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { type ChartingNoncompliance } from "../api/schema";
import { CHARTING_REDIRECT_PATH, CHARTING_REVIEW_DURATION_IN_HOURS } from "../constants";

interface ChartingRecallCardProps {
  chartingNoncompliance: ChartingNoncompliance;
}

export function ChartingRecallCard(props: ChartingRecallCardProps) {
  const { chartingNoncompliance } = props;
  const theme = useTheme();
  const history = useHistory();
  const {
    id: chartingNoncomplianceId,
    attributes: { deadlineToChart },
  } = chartingNoncompliance;
  const hoursUntilChartDeadline = isDefined(deadlineToChart)
    ? Math.floor(differenceInMinutes(deadlineToChart, new Date()) / 60)
    : CHARTING_REVIEW_DURATION_IN_HOURS;

  return (
    <ChartingCardWrapper
      image={UnfinishedTask}
      background={theme.palette.charting?.recall.gradient}
    >
      <BaseChartingCard
        title="Incomplete Charting"
        content={
          <Text variant="body1" textAlign="left">
            Complete charting within {hoursUntilChartDeadline}{" "}
            {pluralize("hour", hoursUntilChartDeadline)} to maintain shift access
          </Text>
        }
        footer={
          <Button
            invert
            sx={{
              width: "fit-content",
            }}
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.CHARTING_NONCOMPLIANCE_RESOLVE_INCOMPLETE_CHARTING, {
                timestamp: new Date().toISOString(),
                chartingNoncomplianceId,
              });
              history.push(CHARTING_REDIRECT_PATH);
            }}
          >
            Resolve now&nbsp;&nbsp;&nbsp;
            <CbhIcon type="chevron-right" size="xSmall" />
          </Button>
        }
      />
    </ChartingCardWrapper>
  );
}
